/* eslint-disable @typescript-eslint/camelcase */
import * as types from '@/constants/matter/types';
import * as materialList from '@/constants/matter/materialList';
import * as advanceCreditInformation from '@/constants/matter/advanceCreditInformation';
import * as mainCreditInfomation from '@/constants/matter/mainCreditInfomation';
import * as fixedMatterInformation from '@/constants/matter/fixedMatterInformation';
import appState from '@/store/app';

/** 登録ガイドメッセージ */
export const authorityValidMessage = 'この内容でよろしければ「登録する」を押してください';
export const authorityInvalidMessage = '登録権限を持たないユーザです';
export const registerFinishText = '登録が完了いたしました';

/** 送信タブ */
export const mailTextAnnotation = '※メール送信時、"%"で囲まれている文字は同一画面に存在する項目名の内容で置換されて送信されます。'
// メール送信ボタン関連
export const previewDialog = {
  isPreviewDialog: false,
  isMailSendDisabled: true,
  name: 'preview',
  title: 'メール送信画面',
  text: '送信されるメール本文をご確認ください',
  mailPreviewText: '',
  buttonTextOK: 'メール送信',
  buttonTextNG: '閉じる'
};
export const sendDialog = {
  isSendDialog: false,
  title: '',
  text: 'メール送信がクリックされました。\n設定した内容でメールを送信しますか？',
  buttonTextOK: 'はい',
  buttonTextNG: 'いいえ'
};
export const sendCompletedDialog = {
  isSendDialog: false,
  title: '',
  text: '送信処理を実行しました'
};

export const Messages: types.KeyValueObject = {
  error: 'エラーにより処理できませんでした'
};

export const CreateButtons: any = [
  {
    id: 1,
    color: 'primary',
    type: 'routing',
    name: 'toEdit',
    value: '詳細画面へ',
    route: '/matter/edit/:id'
  }
];
export const EditButtons: any = [
  {
    id: 1,
    color: 'primary',
    type: 'reload',
    name: 'toEdit',
    value: '詳細画面へ',
  }
];

export const RelatedDatastoreNames: { [key: string]: string } = {
  projectServiceOA: '案件サービス別OA',
  projectServiceGeneral: '案件サービス別汎用',
  projectServiceFJapan: '案件サービス別F-Japan'
};

export const RelatedDatastoreNamesOA: { [key: string]: string } = {
  projectServiceOA: '案件サービス別OA',
  projectCreditOA: '案件与信OA'
};

export const RelatedDatastoreNamesGeneral: { [key: string]: string } = {
  projectServiceGeneral: '案件サービス別汎用'
};

export const RelatedDatastoreNamesFJapan: { [key: string]: string } = {
  projectServiceFJapan: '案件サービス別F-Japan'
};

export const MatterInfomationRegisterData: types.KeyValueObject = {
  customer_id: '',
  telephone_number: '',
  project_name: '',
  department_billing_address_id: '',
  billing_payment_information: '',
  department_delivery_destination_id: '',
  installation_address: '',
  service_type_id: '',
  payment_information: '',
  order_manager_code: '',
  expected_sales_month: '',
  schedule_project_completion_date: '',
  project_completion_date: '',
  expected_sales_date: '',
  relatedItems: {
    projectServiceOA: {
      credit_status: '',
      advanceCreditInformation: []
    },
    projectServiceGeneral: {},
    projectServiceFJapan: {}
  }
};

export const MatterInfomationEditData: types.KeyValueObject = {
  customer_id: '',
  telephone_number: '',
  project_name: '',
  department_billing_address_id: '',
  billing_payment_information: '',
  department_delivery_destination_id: '',
  installation_address: '',
  service_type_id: '',
  payment_information: '',
  order_manager_code: '',
  relatedItems: {
    projectServiceOA: {
      credit_status: '',
      advanceCreditInformation: [],
      creditInformation: []
    },
    projectServiceGeneral: {},
    projectServiceFJapan: {}
  }
};

export const SearchItems: types.SearchItems = {
  Client: {
    Large: {
      findItemName: 'customer_id',
      setItemValue: 'customer_id',
      setItemText: 'customer_id'
    },
    Small: {
      findItemName: 'customer_name',
      setItemValue: 'customer_name',
      setItemText: 'customer_name'
    }
  },
  CustomerDepartment: {
    Large: {
      findItemName: 'department_id',
      setItemValue: 'department_id',
      setItemText: 'department_id'
    },
    Small: {
      findItemName: 'department_name',
      setItemValue: 'department_name',
      setItemText: 'department_name'
    }
  }
};

export const MatterHeaderColumns: any = [
  {
    //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
    'search': false,
    'show_list': false,
    'as_title': false,
    'status': false,
    'fieldIndex': 1,
    'title_order': 1,
    'full_text': false,
    'unique': false,
    'min_value': '',
    'max_value': '',
    // ****** //
    'field_id': '案件登録者',
    'name': 'created_by',
    'display_id': 'created_by',
    'dataType': 'text',
    'component': 'InputArea',
    'props':{
      'labelName':'案件登録者',
      'labelText':'案件登録者',
      'name':'created_by',
      'isReadonly':true,
      'isDisabled':true,
      'rules':'',
      'value': ''
    },
    'sizeX':1,
    'sizeY':1,
    'col':0,
    'row':0,
    'show':true,
  },
  {
    //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
    'search': false,
    'show_list': false,
    'as_title': false,
    'status': false,
    'fieldIndex': 1,
    'title_order': 1,
    'full_text': false,
    'unique': false,
    'min_value': '',
    'max_value': '',
    // ****** //
    'field_id': '案件登録日',
    'name': 'created_at',
    'display_id': 'created_at',
    'dataType': 'text',
    'component': 'InputArea',
    'props':{
      'labelName':'案件登録日',
      'labelText':'案件登録日',
      'name':'created_at',
      'isReadonly':true,
      'isDisabled':true,
      'rules':'',
      'value': ''
    },
    'sizeX':1,
    'sizeY':1,
    'col':1,
    'row':0,
    'show':true,
  }
]

export const MasterSelectDataColumns: types.DataColumns = {
  Customer: [
    { text: '見込顧客番号', value: 'customer_id', width: '70' },
    { text: '顧客名', value: 'customer_name', width: '80' },
    { text: '顧客連絡先', value: 'telephone_number', width: '120' }
  ],
  CustomerDepartmentFrom: [
    { text: '部署番号', value: 'department_id', width: '70' },
    { text: '部署名', value: 'department_name', width: '80' },
    { text: '部署名カナ', value: 'department_name_kana', width: '120' },
  ],
  CustomerDepartmentTo: [
    { text: '部署番号', value: 'department_id', width: '70' },
    { text: '部署名', value: 'department_name', width: '120' },
    { text: '部署名カナ', value: 'department_name_kana', width: '120' },
    { text: '都道府県', value: 'prefectures', width: '70' },
    { text: '市町区', value: 'municipalities', width: '70' },
    { text: '町村丁番地', value: 'machimura_street_address', width: '120' },
    { text: 'ビル・建物名', value: 'building_name', width: '120' }
  ],
  ServiceType: [
    { text: 'サービス種別コード', value: 'id', width: '70' },
    { text: 'サービス種別', value: 'service_type', width: '80' }
  ],
  orderManagerCode: [
    { text: '担当者コード', value: 'order_manager_code', width: '70' },
    { text: '案件担当者', value: 'name', width: '80' }
  ]
};

export const MasterSelectDataBodies: any = {
  Customer: [
    { label: '顧客', isDisplyLabel: false, displayId: 'customer_id', name: 'customer_name', isReadOnly: true }
  ],
  CustomerDepartmentFrom: [
    { label: '顧客部署(申込元・請求先)', isDisplyLabel: false, displayId: 'department_billing_address_id', name: 'department_name', isReadOnly: true, value: '' }
  ],
  CustomerDepartmentTo: [
    { label: '顧客部署(設置先・納入先)', isDisplyLabel: false, displayId: 'department_delivery_destination_id', name: 'department_name', isReadOnly: true, value: '' }
  ],
  ServiceType: [
    { label: 'サービス種別', isDisplyLabel: false, displayId: 'service_type_id', name: 'service_type', isReadOnly: true }
  ]
};

export const PaymentTypeItem: types.SelectItemProps = {
  label: '',
  name: 'select',
  disabled: false,
  selected: 0,
  dense: false,
  options: []
};

export const CreditStatusPanelMasterSelectData: any = {
  selectCreditStatusItem: {
    label: '',
    name: 'select',
    disabled: false,
    dense: true,
    options: []
  }
};

export const MaterialListTabItems: types.TabItemsProps = {
  Create: {
    1: [
      {
        title: '構成表・見積作成',
        component: 'MaterialListTab',
        disabled: false,
        editable: true,
        statusButton: [],
        execAllowActions: [],
        tableParameters: materialList.TableParametersOA,
        isFileManagerDisabled: true
      } as types.MaterialListTabItemProps
    ] as Array<types.TabItemProps>,
    2: [
      {
        title: '構成表・見積作成',
        component: 'MaterialListTab',
        disabled: true,
        editable: false,
        statusButton: [],
        execAllowActions: [],
        tableParameters: materialList.TableParametersFJapan,
        isFileManagerDisabled: true
      } as types.MaterialListTabItemProps
    ] as Array<types.TabItemProps>,
    99: [
      {
        title: '構成表・見積作成',
        component: 'MaterialListTab',
        disabled: true,
        editable: false,
        statusButton: [],
        execAllowActions: [],
        tableParameters: materialList.TableParametersGeneral,
        isFileManagerDisabled: true
      } as types.MaterialListTabItemProps
    ] as Array<types.TabItemProps>,
  },
  Update: {
    1: [
      {
        title: '構成表・見積作成',
        component: 'MaterialListTab',
        disabled: false,
        statusButton: [{
          action_id: "create_estimate",
          action_name: "構成表を新規登録する",
          crud_type: "",
          display_id: "redirect_estimate",
          display_order: 0
        }],
        execAllowActions: [{
          action_id: "create_estimate",
          action_name: "構成表を新規登録する",
          crud_type: "",
          display_id: "redirect_estimate",
          display_order: 0
          }
        ],
        tableParameters: materialList.TableParametersOA,
        isFileManagerDisabled: true
      } as types.MaterialListTabItemProps,
    ] as Array<types.TabItemProps>,
    2: [
      {
        title: '構成表・見積作成',
        component: 'MaterialListTab',
        disabled: false,
        statusButton: [{
          action_id: "create_estimate",
          action_name: "構成表を新規登録する",
          crud_type: "",
          display_id: "redirect_estimate",
          display_order: 0
        }],
        execAllowActions: [{
          action_id: "create_estimate",
          action_name: "構成表を新規登録する",
          crud_type: "",
          display_id: "redirect_estimate",
          display_order: 0
        }],
        tableParameters: materialList.TableParametersFJapan,
        isFileManagerDisabled: true
      } as types.MaterialListTabItemProps,
    ] as Array<types.TabItemProps>,
    99: [
      {
        title: '構成表・見積作成',
        component: 'MaterialListTab',
        disabled: false,
        statusButton: [{
          action_id: "create_estimate",
          action_name: "構成表を新規登録する",
          crud_type: "",
          display_id: "redirect_estimate",
          display_order: 0
        }],
        execAllowActions: [{
          action_id: "create_estimate",
          action_name: "構成表を新規登録する",
          crud_type: "",
          display_id: "redirect_estimate",
          display_order: 0
        }],
        tableParameters: materialList.TableParametersGeneral,
        isFileManagerDisabled: true
      } as types.MaterialListTabItemProps,
    ] as Array<types.TabItemProps>
  }
}

export const MatterTabItems: types.TabItemsProps = {
  Create: {
    1: [
      {
        title: '事前与信',
        component: '',
        disabled: true,
        editable: false,
        rules: {}
      },
      {
        title: '本信',
        component: '',
        disabled: true,
        editable: false,
        rules: {}
      },
      {
        title: '契約',
        component: '',
        disabled: true,
        editable: false,
        rules: {}
      }
    ] as Array<types.TabItemProps>,
    2: [
      {
        title: '送信',
        component: '',
        disabled: true,
        editable: false,
        rules: {}
      }
    ] as Array<types.TabItemProps>,
    99: [
      {
        title: '契約',
        component: '',
        disabled: true,
        editable: false,
        rules: {}
      }
    ] as Array<types.TabItemProps>
  },
  Update: {
    1: [
      {
        title: '事前与信',
        component: 'AdvanceCreditInformationTab',
        disabled: false,
        editable: true,
        rules: {},
        creditList: {
          isDisabledAddItemButtonFlag: true,
          tableParameters: materialList.ProjectCreditTableParameters
        },
        masterSelectItem: {},
        dialogControl: {
          register: false
        },
        applyDialogTitle: '',
        applyDialogItems: {}
      },
      {
        title: '本信',
        component: 'MainCreditInfomationTab',
        disabled: false,
        editable: {
          true_status: false,
          leasing_company_id: false,
          approval_number: false,
          special_notes: false
        },
        rules: {},
        masterSelectData: JSON.parse(JSON.stringify(CreditStatusPanelMasterSelectData)),
        mainCreditStatusData: mainCreditInfomation.MainCreditStatusData,
        leasingCompanyOutputData: mainCreditInfomation.LeasingCompanyOutputData
      },
      {
        title: '契約',
        component: 'ContractInfomationTab',
        disabled: false,
        editable: {
          registerButton: false,
          contractFile: true
        },
        selectContractTypeItems: {
          value: '',
          selectData: []
        },
        dialogControl: {
          register: false,
          detailConfirm: false,
        },
        isDocurainTemplateDownloadButton: true,
        fileUploadItems: {},
        dialogTitle: '',
        partnerSignaturePositionItems: {},
        ourSignaturePositionItems: {},
        dialogButtonType: true,
        accessCode: {
          access_code: '',
          isShowAccessCode: false
        },
        downloadFileInformation: { name: '', fileId: ''},
        radioItem: {
          selectView: 1,
          default: 1,
          option: {
            name: '契約タイプ切替',
            options: [
              {
                'option_id': 1,
                'text': '電子契約'
              },
              {
                'option_id': 2,
                'text': '非電子契約'
              }
            ]
          }
        },
        detailItems: {},
        documentManagementTable: {
          columns: [
            { text: '詳細', value: 'detail', width: '8%', sortable: false },
            { text: 'ファイル名', value: 'document_name', width: '40%' },
            { text: '署名依頼日', value: 'signature_request_date', width: '12%' },
            { text: '署名完了日時', value: 'lastSigningDatetime', width: '14%' },
            { text: 'ステータス', value: 'document_status', width: '12%' },
            { text: '署名依頼ダウンロード', value: 'download', width: '14%', sortable: false  },
            { text: '自動更新', value: 'matter_status_update_flag', width: '5%', sortable: false }
          ],
          body: [],
          buttonItems: [
            {
              'alwaysDisplayed': false,
              'class': 'btn-normal',
              'name': 'detail',
              'text': '詳細'
            },
            {
              'alwaysDisplayed': false,
              'class': 'btn-normal',
              'name': 'download',
              'text': 'ダウンロード',
              'disabled': true
            }
          ]
        },
        buttonItems: fixedMatterInformation.ButtonItems,
        nonElectronicContractList: [],
        nonElectronicContractcolumns: [
          { text: 'ファイル名', value: 'name' },
          { text: 'サイズ（byte）', value: 'size' }
        ],
        isLoading: false,
        rules: {}
      },
      {
        matterDsId: 't_project_service_OA',
        projectServiceDsId: '',
        title: '送信',
        component: 'SendTab',

        disabled: false,
        showDialog: false,
        isFileManagerDisabled: true,
        isDisabledPreviewButton: false,
        editable: {
          formSelectButton: false
        },
        sendTargetFile: {
          title: '送信対象ファイル',
          fieldId: 'send_file',
          sendFileItemId: '',
          items: []
        },
        sendTargetMail: {
          title: '送信先メールアドレス',
          items: [
            {
              name: 'send_target',
              label: '送信先',
              value: '',
              rule: 'send_tab_input_item_required|email'
            },
            {
              name: 'send_target',
              value: '',
              rule: 'email'
            },
            {
              name: 'send_target',
              value: '',
              rule: 'email'
            }
          ]
        },
        mailTitle: {
          title: '件名',
          name: 'mail_title',
          value: '',
          rule: 'send_tab_input_item_required'
        },
        sendMailText: {
          title: 'メール本文',
          items: [
            {
              name: 'mail_text',
              value: '',
              placeholder: '',
              isDisabled: false
            }
          ]
        },
        fileSelect: {
          title: '添付ファイル選択',
          items: []
        },
        dialogControl: false,
        dialogTitle: '見積書添付',
        estimateFormData: {
          buttonItems: [],
          columnsItems: [
            {
              text: "見積ファイル名",
              value: "name"
            },
            {
              text: "サイズ（byte）",
              value: "size"
            }
          ],
          fileList: [],
          editable: true,
          isSubmit: true,
          isCancel: true,
          buttonSubmitText: 'OK',
          buttonCancelText: '閉じる',
          isSubmitDisable: false,
          isCancelDisable: false,
          isTextActionButton: false
        },
        rules: '',
        accept: ''
      }
    ] as Array<types.TabItemProps>,
    2: [
      {
        matterDsId: 't_project_service_fjapan',
        projectServiceDsId: '',
        title: '送信',
        component: 'SendTab',

        disabled: false,
        showDialog: false,
        isFileManagerDisabled: true,
        isDisabledPreviewButton: false,
        editable: {
          formSelectButton: false
        },
        sendTargetFile: {
          title: '送信対象ファイル',
          fieldId: 'send_file',
          sendFileItemId: '',
          items: []
        },
        sendTargetMail: {
          title: '送信先メールアドレス',
          items: [
            {
              name: 'send_target',
              label: '送信先',
              value: '',
              rule: 'send_tab_input_item_required|email'
            },
            {
              name: 'send_target',
              value: '',
              rule: 'email'
            },
            {
              name: 'send_target',
              value: '',
              rule: 'email'
            }
          ]
        },
        mailTitle: {
          title: '件名',
          name: 'mail_title',
          value: '',
          rule: 'send_tab_input_item_required'
        },
        sendMailText: {
          title: 'メール本文',
          items: [
            {
              name: 'mail_text',
              value: '',
              placeholder: '',
              isDisabled: false
            }
          ]
        },
        fileSelect: {
          title: '添付ファイル選択',
          items: []
        },
        dialogControl: false,
        dialogTitle: '見積書添付',
        estimateFormData: {
          buttonItems: [],
          columnsItems: [
            {
              text: "見積ファイル名",
              value: "name"
            },
            {
              text: "サイズ（byte）",
              value: "size"
            }
          ],
          fileList: [],
          editable: true,
          isSubmit: true,
          isCancel: true,
          buttonSubmitText: 'OK',
          buttonCancelText: '閉じる',
          isSubmitDisable: false,
          isCancelDisable: false,
          isTextActionButton: false
        },
        rules: '',
        accept: ''
      }
    ] as Array<types.TabItemProps>,
    99: [
      {
        title: '契約',
        component: 'ContractInfomationTab',
        disabled: false,
        editable: {
          registerButton: false,
          contractFile: true
        },
        selectContractTypeItems: {
          value: '',
          selectData: []
        },
        dialogControl: {
          register: false,
          detailConfirm: false,
        },
        isDocurainTemplateDownloadButton: false,
        fileUploadItems: {},
        dialogTitle: '',
        partnerSignaturePositionItems: {},
        ourSignaturePositionItems: {},
        dialogButtonType: true,
        accessCode: {
          access_code: '',
          isShowAccessCode: false
        },
        downloadFileInformation: { name: '', fileId: ''},
        radioItem: {
          selectView: 1,
          default: 1,
          option: {
            name: '契約タイプ切替',
            options: [
              {
                'option_id': 1,
                'text': '電子契約'
              },
              {
                'option_id': 2,
                'text': '非電子契約'
              }
            ]
          }
        },
        detailItems: {},
        documentManagementTable: {
          columns: [
            { text: '詳細', value: 'detail', width: '8%', sortable: false },
            { text: 'ファイル名', value: 'document_name', width: '40%' },
            { text: '署名依頼日', value: 'signature_request_date', width: '12%' },
            { text: '署名完了日時', value: 'lastSigningDatetime', width: '14%' },
            { text: 'ステータス', value: 'document_status', width: '12%' },
            { text: '署名依頼ダウンロード', value: 'download', width: '14%', sortable: false  },
            { text: '自動更新', value: 'matter_status_update_flag', width: '5%', sortable: false }
          ],
          body: [],
          buttonItems: [
            {
              'alwaysDisplayed': false,
              'class': 'btn-normal',
              'name': 'detail',
              'text': '詳細'
            },
            {
              'alwaysDisplayed': false,
              'class': 'btn-normal',
              'name': 'download',
              'text': 'ダウンロード',
              'disabled': true
            }
          ]
        },
        buttonItems: fixedMatterInformation.ButtonItems,
        nonElectronicContractList: [],
        nonElectronicContractcolumns: [
          { text: 'ファイル名', value: 'name' },
          { text: 'サイズ（byte）', value: 'size' }
        ],
        isLoading: false,
        rules: {}
      },
      {
        matterDsId: 't_project_service_general',
        projectServiceDsId: '',
        title: '送信',
        component: 'SendTab',

        disabled: false,
        showDialog: false,
        isFileManagerDisabled: true,
        isDisabledPreviewButton: false,
        editable: {
          formSelectButton: false
        },
        sendTargetFile: {
          title: '送信対象ファイル',
          fieldId: 'send_file',
          sendFileItemId: '',
          items: []
        },
        sendTargetMail: {
          title: '送信先メールアドレス',
          items: [
            {
              name: 'send_target',
              label: '送信先',
              value: '',
              rule: 'send_tab_input_item_required|email'
            },
            {
              name: 'send_target',
              value: '',
              rule: 'email'
            },
            {
              name: 'send_target',
              value: '',
              rule: 'email'
            }
          ]
        },
        mailTitle: {
          title: '件名',
          name: 'mail_title',
          value: '',
          rule: 'send_tab_input_item_required'
        },
        sendMailText: {
          title: 'メール本文',
          items: [
            {
              name: 'mail_text',
              value: '',
              placeholder: '',
              isDisabled: false
            }
          ]
        },
        fileSelect: {
          title: '添付ファイル選択',
          items: []
        },
        dialogControl: false,
        dialogTitle: '見積書添付',
        estimateFormData: {
          buttonItems: [],
          columnsItems: [
            {
              text: "見積ファイル名",
              value: "name"
            },
            {
              text: "サイズ（byte）",
              value: "size"
            }
          ],
          fileList: [],
          editable: true,
          isSubmit: true,
          isCancel: true,
          buttonSubmitText: 'OK',
          buttonCancelText: '閉じる',
          isSubmitDisable: false,
          isCancelDisable: false,
          isTextActionButton: false
        },
        rules: '',
        accept: ''
      }
    ] as Array<types.TabItemProps>
  }
};

// 各情報で除外するステータス
export const ExclusionStatus = {
  credit: '削除済',
  estimate: '削除済',
  fixedEstimate: ['一時保存中', '削除済']
}


export const CopyDSNames: { [key: string]: string } = {
  estimateBasicInfomationGeneral: '見積基本情報汎用',
  estimateBasicInfomationOA: '見積基本情報OA',
  estimateBasicInfomationFJapan: '見積基本情報F-Japan',
  estimateDetail: '見積明細',
  estimateDatailAddInput: '明細追加入力',
  material: '構成表',
}

export const CopyDSNamesOA: { [key: string]: string } = {
  estimateBasicInfomationOA: '見積基本情報OA',
  estimateDetail: '見積明細',
  estimateDatailAddInput: '明細追加入力',
  material: '構成表',
}

export const CopyDSNamesGeneral: { [key: string]: string } = {
  estimateBasicInfomationGeneral: '見積基本情報汎用',
  estimateDetail: '見積明細',
  estimateDatailAddInput: '明細追加入力',
  material: '構成表',
}

export const CopyDSNamesFJapan: { [key: string]: string } = {
  estimateBasicInfomationFJapan: '見積基本情報F-Japan',
  estimateDetail: '見積明細',
  estimateDatailAddInput: '明細追加入力',
  material: '構成表',
}

export const ContractSendData: any = {
	'temp_token': '',
	'application_id': '',
	'company_datastore_id': '',
	'company_id': '',
	'signing_datastore_id': '',
	'signing_group_id': '',
	'project_id': '',
	'partner_signing_name_list': [{}],
	'partner_signing_email_list': [{}],
	'our_signing_name_list': [{}],
	'our_signing_email_list': [{}],
	'two_step_approval_mail': '',
	'access_code': '',
	'thank_doc': '',
	'organize_nm': '',
	'documents_datastore_id': '',
	'document_name': '',
	'post_nm': '',
	'name_nm': '',
	'simwork_email': '',
  'system_contract_number': '',
  'conclusion_date': null,
  'agreement_end_date': null,
  'agreement_start_date': null,
  'contract_amount': '',
  'long_storage': null,
  'partner_comment': '',
  'our_comment': '',
  'complete_email': '',
  'matter_status_update_flag': null
};

export const DocumentStatus: any = {
  '01': '押印依頼中',
  '10': '押印依頼中',
  '90': '押印依頼中(最終処理)',
  '91': '押印依頼中(最終処理)',
  '92': '押印依頼中(最終処理)',
  '93': '押印依頼中(最終処理)',
  '94': '押印依頼中(最終処理)',
  '95': '契約合意',
  '98': '否認',
  '99': '途中終了',
};
//マスタに切り出す => シムワークから送られてくる

// 与信商品マスタ選択のカラム
export const CreditProductColumns = [
  { text: '商品コード', value: 'product_code', width: '80' },
  { text: 'リース会社名', value: 'leasing_company_id', width: '80' },
  { text: '商品区分', value: 'product_classification', width: '80' },
  { text: '商品名', value: 'prodact_name', width: '80' },
  { text: '備考', value: 'remarks', width: '80' }
];
// 大項目検索設定(同じdisplay_id)
export const CreditProductSearchLargeItemData: any = {
  findItemName: 'leasing_company_id',
  setItemValue: 'leasing_company_id',
  setItemText: 'leasing_company_id'
};
// 小項目検索設定(同じdisplay_id)
export const CreditProductSearchSmallItemData: any = {
  findItemName: 'product_classification',
  setItemValue: 'product_classification',
  setItemText: 'product_classification'
};
